<template>
  <ul>
    <!--    eslint-disable-->
    <component
      :is="resolveNavItemComponent(item)"
      v-for="item in items"
      v-if="checkPermission(item.permission)"
      :key="item.header || item.title"
      :item="item"
    />
  </ul>
</template>

<script>
import { resolveVerticalNavMenuItemComponent as resolveNavItemComponent } from '@core/layouts/utils'
import { provide, ref } from '@vue/composition-api'
import { mapGetters } from 'vuex'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import VerticalNavMenuHeader from '../vertical-nav-menu-header'
import VerticalNavMenuLink from '../vertical-nav-menu-link/VerticalNavMenuLink.vue'
import VerticalNavMenuGroup from '../vertical-nav-menu-group/VerticalNavMenuGroup.vue'

const MerchantRepository = RepositoryFactory.get('merchant')

export default {
  components: {
    VerticalNavMenuHeader,
    VerticalNavMenuLink,
    VerticalNavMenuGroup,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      isWebhookEnable: false,
    }
  },
  setup() {
    provide('openGroups', ref([]))
    return {
      resolveNavItemComponent,
    }
  },
  computed: {
    ...mapGetters(['permissions', 'permissionObjects', 'isPermissionActive']),
  },
  created() {
    this.getMerchantBusinessSettingsDetails()
  },
  methods: {
    async getMerchantBusinessSettingsDetails() {
      try {
        const data = localStorage.getItem('merchant_business_setting') ? JSON.parse(localStorage.getItem('merchant_business_setting')) : (await MerchantRepository.getMerchantBusinessSettingsDetails()).data.data
        if (!localStorage.getItem('merchant_business_setting')) localStorage.setItem('merchant_business_setting', JSON.stringify(data))
        this.isWebhookEnable = data.is_webhook_enable
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    // Check if any of the route permissions exist and are active
    checkPermission(routePermissions) {
      if (!routePermissions) return true // If no specific permissions are required, show the item.

      // IMPORTANT CHANGE: If permissions are not yet loaded, hide the item by default.
      // This prevents the flicker. We assume that if permissions are not available yet,
      // we shouldn't show permission-gated items.
      if (!this.permissionObjects || this.permissionObjects.length === 0) {
        // If permissionObjects are not loaded, and the item requires permissions,
        // we should hide it. This is safer than showing it.
        return false
      }

      // Check if this is a webhook-related permission
      const webhookPermissions = ['view-webhook', 'show-webhook', 'create-webhook', 'edit-webhook', 'view-webhook-logs', 'show-webhook-logs']
      const isWebhookPermission = routePermissions.some(perm => webhookPermissions.includes(perm))

      if (isWebhookPermission) {
        if (!this.isWebhookEnable) {
          return false
        }
        // For webhook permissions, check both existence and is_active === 1
        return routePermissions.some(permissionName => {
          const permission = this.permissionObjects.find(p => p.name === permissionName)
          return permission && permission.is_active === 1
        })
      }

      // For non-webhook permissions, use the existing logic (checking against the flat 'permissions' array)
      // We still need to ensure this.permissions is loaded.
      if (!this.permissions || this.permissions.length === 0) {
        return false // Hide if flat permissions also not loaded
      }
      return this.permissions.some(i => routePermissions.includes(i))
    },
  },
}
</script>
